import { Abs, FinancialsAmountOpposite, FinancialsAmount, Money, MoneyNoDecimals, FinancialsSeperatorAmount, IncomeVsBudgetExpenseFilter, IncomeVsBudgetIncomeFilter, IncomeVsBudgetRemainderFilter, IncomeVsBudgetExpenseRemainderFilter, cashflowExpenses, cashflowActuals, cashflowNetFilter, cashflowNetNoColourFilter, levyRollFilter } from '../filters';

export default angular
    .module('pretor.online.filters', [])
    .filter('Abs', Abs)
    .filter('financialsAmountOpposite', FinancialsAmountOpposite)
    .filter('financialsAmount', FinancialsAmount)
    .filter('money', Money)
    .filter('moneyNoDecimals', MoneyNoDecimals)
    .filter('financialsSeperatorAmount', FinancialsSeperatorAmount)
    .filter('IncomeVsBudgetExpenseFilter', IncomeVsBudgetExpenseFilter)
    .filter('IncomeVsBudgetIncomeFilter', IncomeVsBudgetIncomeFilter)
    .filter('IncomeVsBudgetRemainderFilter', IncomeVsBudgetRemainderFilter)
    .filter('IncomeVsBudgetExpenseRemainderFilter', IncomeVsBudgetExpenseRemainderFilter)
    .filter('cashflowExpenses', cashflowExpenses)
    .filter('cashflowActuals', cashflowActuals)
    .filter('cashflowNetFilter', cashflowNetFilter)
    .filter('cashflowNetNoColourFilter', cashflowNetNoColourFilter)
    .filter('levyRollFilter', levyRollFilter); 
